<template>
    <div class="company-image" :class="{'company-image--loaded' : src, 'company-image--error': error}">
        <img v-if="src && !error" class="u-img-responsive" :src="src" @error="error = true"/>
        <div v-else-if="!src && !error" class="company-image--loading">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>

<script>
  import config from '@/config'

  export default {
    props: ['slug'],
    name: 'ba-company-image',
    data () {
      return {
        src: null,
        error: false,
      }
    },
    mounted () {
      const companyId = this.$route.params.companyId
      // Use img src directly - follows Django 302 redirect to S3 without CORS issues.
      // axios blob + FileReader broke because redirected S3 requests use Origin: null
      // which S3 CORS does not match.
      this.src = `${config.url}/company/${companyId}/image/${this.slug}/`
    },
  }
</script>

<style scoped>
    .company-image {
        display: inline-block;
        min-height: 40px;
        min-width: 40px;
    }
    .company-image--loading {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        font-size: 24px;
    }
</style>
